import { TableInstallments } from "./table/TableInstallments";

export const PageInstallmentsAll = () => {
  return <TableInstallments />;
};
